/* global axios */
import ApiClient from './ApiClient';

class LiveVisitorsAPI extends ApiClient {
  constructor() {
    super('live_visitors', { accountScoped: true });
  }

  get(page = 1) {
    return axios.get(`${this.url}?page=${page}`);
  }

  createConversation({ contact_id, inbox_id, message }) {
    return axios.post(`${this.url}/create_conversation`, {
      contact_id,
      inbox_id,
      message,
    });
  }
}

export default new LiveVisitorsAPI();
